import { ProductVariantOption } from "@prisma/client";
import classNames from "classnames";
import { VariantWithRelations } from "Types";
import { useMenuContext } from "context/MenuContext";
import { getTranslation } from "dictionary";
import { useUserContext } from "context/UserContext";
import { getFormatedPrice } from "helpers";

interface Props {
  variant: VariantWithRelations;
  handleSelection: (option: ProductVariantOption) => void;
  selectedOption?: string;
}

const VariantSelection: React.FC<Props> = ({
  variant,
  selectedOption,
  handleSelection,
}) => {
  const { currency_symbol } = useMenuContext();
  const { language } = useUserContext();
  return (
    <div className="space-y-2 my-4" id={variant.id}>
      <div className="flex items-center ">
        <span className="">{variant.title}</span>

        {variant.isRequired && !selectedOption ? (
          <span className="text-sm font-light text-gray-600 ml-2">
            {getTranslation("menu_product", "SELECT_ONE", language)}
          </span>
        ) : null}
      </div>
      <div className="flex flex-wrap gap-3">
        {variant.options.map((option) =>
          option.status === "hidden" ? null : (
            <button
              aria-label={option.title}
              disabled={option.status === "not_available"}
              key={option.id}
              className={classNames(
                "py-2 px-4 flex justify-between gap-1 items-center overflow-hidden rounded-lg border-gray-300 border  disabled:opacity-50 disabled:cursor-not-allowed",
                {
                  "border-gray-600": selectedOption === option.id,
                },
                {
                  "bg-gray-200 shadow-none cursor-not-allowed":
                    option.status === "not_available",
                }
              )}
              onClick={() =>
                option.status === "available" ? handleSelection(option) : {}
              }
            >
              {option.title}
              {option.price > 0 && (
                <span className="text-gray-new text-right text-xs ml-2">
                  + {getFormatedPrice(option.price, currency_symbol)}
                </span>
              )}
            </button>
          )
        )}
      </div>
    </div>
  );
};
export default VariantSelection;
